import { Repetidor } from "../../class/index";
export default {
    data() {
        return {
            user: null,
            cliente: {}
        };
    },
    methods: {
        loadPonto() {
            if (this.$route.params.id) {
                Repetidor.byID(this.$route.params.id)
                    .then(row => this.$store.commit("setRepetidor", row))
                    .catch(() =>
                        this.$store.commit("setRepetidor", Repetidor.create())
                    );
            }
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.loadPonto(this.$route.params.id);
        } else {
            this.$store.commit("setRepetidor", Repetidor.create());
        }
    }
};
